import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import decksService from './decksService'

const initialState = {
	decks: [],
	isError: false,
	isSuccess: false,
	isLoading: false,
	message: '',
}

export const getDecks = createAsyncThunk('images/getDecks', async (thunkAPI) => {
	try {
		return await decksService.getDecks()
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString()

		return thunkAPI.rejectWithValue(message)
	}
})

export const decksSlice = createSlice({
	name: 'decks',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getDecks.pending, (state) => {
				state.isLoading = true
			})
			.addCase(getDecks.fulfilled, (state, action) => {
				state.isLoading = false
				state.isSuccess = true
				state.decks = action.payload
			})
			.addCase(getDecks.rejected, (state, action) => {
				state.isLoading = false
				state.isError = true
				state.decks = []
				state.message = action.payload
			})
	},
})

export default decksSlice.reducer
